export default {
  Title: 'Caregivers',
  Action: 'Create new caregiver',
  CaregiverStatus: 'Caregiver status: ',
  Clients: 'Clients: ',
  DefaultName: 'Caregiver',
  Client: 'Clients: #{names}',
  Update: 'Update',
  Languages: {
    Extra: '+#{count}',
  },
  YearsExperience: '• #{count} year of experience',
  Filter: {
    Status: 'Status',
    Location: 'Location',
    CaregiverName: 'Caregiver Name',
    MapEnabled: 'Map Enabled',
    MapDisabled: 'Map Disabled',
    Certification: 'Certification',
    Languages: 'Languages',
  },
  YearsOfExperience: '#{years} Yrs #{months} Months of experience',
  CreatedAt: 'Created on #{date}',
  Map: {
    Disable: 'Disable',
    Enable: 'Enable',
    Radius: 'Radius: #{radius} km',
    ShowingCountView: 'Showing #{count} caregiver in view',
    ShowingCountRadius: 'Showing #{count} caregivers within #{radius} km',
    SearchPlaceholder: 'Search location (e.g., Toronto, ON)',
    RadiusFilter: 'Radius Filter',
    Search: 'Search',
  },
  Selected: 'Selected',
};
